import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./services/auth.guard";
export const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  {
    path: "home",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pages/home/home.module").then((m) => m.HomePageModule),
  },
  {
    path: "login",
    loadChildren: () =>
      import("./pages/login/login.module").then((m) => m.LoginPageModule),
  },
  {
    path: "profile",
    loadChildren: () =>
      import("./pages/profile/profile.module").then((m) => m.ProfilePageModule),
    canActivate: [AuthGuard],
  },
  {
    path: "epub/:id",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pages/epub/epub.module").then((m) => m.EpubPageModule),
  },
  {
    path: "index",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pages/index/index.module").then((m) => m.IndexPageModule),
  },
  {
    path: "publication-index/:type",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pages/publication-index/publication-index.module").then(
        (m) => m.PublicationIndexPageModule
      ),
  },
  {
    path: "seikyo-index",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pages/seikyo-index/seikyo-index.module").then(
        (m) => m.SeikyoIndexPageModule
      ),
  },
  {
    path: "old-publications",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pages/old-index/old-index.module").then(
        (m) => m.OldIndexPageModule
      ),
  },
  {
    path: "pdf/:id",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pages/pdf/pdf.module").then((m) => m.PdfPageModule),
  },
  {
    path: "register",
    loadChildren: () =>
      import("./pages/register/register.module").then(
        (m) => m.RegisterPageModule
      ),
  },
  {
    path: "forgotten-password",
    loadChildren: () =>
      import("./pages/forgotten-password/forgotten-password.module").then(
        (m) => m.ForgottenPasswordPageModule
      ),
  },
  {
    path: "practice",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pages/practice/practice.module").then(
        (m) => m.PracticePageModule
      ),
  },
  {
    path: "practice/:id",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pages/practice/practice.module").then(
        (m) => m.PracticePageModule
      ),
  },
  {
    path: "practice/:id/:type",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pages/practice/practice.module").then(
        (m) => m.PracticePageModule
      ),
  },
  {
    path: "practice/:id/:type/:subtype",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pages/practice/practice.module").then(
        (m) => m.PracticePageModule
      ),
  },
  {
    path: "series",
    loadChildren: () =>
      import("./pages/series/series.module").then((m) => m.SeriesPageModule),
  },
  {
    path: "series/:type",
    loadChildren: () =>
      import("./pages/series/series.module").then((m) => m.SeriesPageModule),
  },
  {
    path: "series/:type/:id",
    loadChildren: () =>
      import("./pages/series/series.module").then((m) => m.SeriesPageModule),
  },
  {
    path: "publications",
    canActivate: [AuthGuard],
    loadChildren: () =>
      import("./pages/publications/publications.module").then(
        (m) => m.PublicationsPageModule
      ),
  },
  {
    path: "media",
    loadChildren: () =>
      import("./pages/media/media.module").then((m) => m.MediaPageModule),
  },
  {
    path: "update-notification",
    loadChildren: () =>
      import(
        "./components/update-notification/update-notification.module"
      ).then((m) => m.UpdateNotificationPageModule),
  },
  // {
  //   path: 'goals',
  //   loadChildren: () => import('./pages/goals/goals.module').then( m => m.GoalsPageModule)
  // },

  // {
  //   path: 'seykio-search',
  //   loadChildren: () => import('../app/pages/seykio-search/seykio-search-routing.module').then( m => m.SeykioSearchPageRoutingModule)
  // },

  {
    path: "seykio-search",
    loadChildren: () =>
      import("./seykio-search/seykio-search.module").then(
        (m) => m.SeykioSearchPageModule
      ),
  },
  {
    path: "eliminar-cuenta",
    loadChildren: () =>
      import("./pages/eliminar-cuenta/eliminar-cuenta.module").then(
        (m) => m.EliminarCuentaPageModule
      ),
  },
  {
    path: "politica-privacidad",
    loadChildren: () =>
      import("./pages/politica-privacidad/politica-privacidad.module").then(
        (m) => m.PoliticaPrivacidadPageModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
